// extracted by mini-css-extract-plugin
export default {"background":"Layout_background__CxORJ"};